import { Component, ViewChild } from '@angular/core';
import { AuthService } from '@core';
import { BillingAddress } from '@models/billing-address';
import { Insurant } from '@models/insurant';
import { BillingAddressFormComponent } from '../../components/billing-address-form/billing-address-form.component';
import { OrderStepBaseComponent } from '../../order-step-base-component';
import { OrderState } from 'app/order/models';

@Component({
    selector: 'app-billing-address',
    templateUrl: './billing-address.component.html',
    styleUrls: ['./billing-address.component.scss'],
    standalone: false,
})
export class BillingAddressComponent extends OrderStepBaseComponent {
    public constructor(public authService: AuthService) {
        super();
    }

    @ViewChild(BillingAddressFormComponent)
    private billingForm: BillingAddressFormComponent;

    public get billingAddress(): Partial<BillingAddress> | undefined {
        return this.state?.billingAddress;
    }

    public get insurants(): Insurant[] | undefined {
        return this.state?.insurants;
    }

    public getData(): Partial<OrderState> | undefined {
        return this.billingForm?.getData();
    }

    public override get isInvalid(): boolean {
        return this.billingForm?.isInvalid;
    }
}
